import type {RouteLocationNormalized} from 'vue-router'
import {ClientRouteParamType} from '@toolify/client/src/setup/router/enum/ClientRouteParamType'

type TRouteForComparison = Pick<RouteLocationNormalized, 'path' | 'params' | 'meta'>

export function isAiResourceAlreadyOpen(target: TRouteForComparison, current: TRouteForComparison): boolean {
  const targetResource = target.meta.determineResource?.(target as RouteLocationNormalized) ?? null
  const currentResource = current.meta.determineResource?.(current as RouteLocationNormalized) ?? null
  if(!targetResource || !currentResource) {
    return target.path === current.path
  }
  if(targetResource.resourceType !== currentResource.resourceType || targetResource.resourceId !== currentResource.resourceId) {
    return false
  }
  const targetViewId = target.params[ClientRouteParamType.DatabaseViewId]
  return !targetViewId || targetViewId === current.params[ClientRouteParamType.DatabaseViewId]
}
